export default function VisionAireLogo({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="120" height="120" rx="20" fill="#0F172A" />
      <path
        d="M30 35L60 90L90 35"
        stroke="#F59E0B"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="60" cy="52" r="12" fill="none" stroke="#F59E0B" strokeWidth="5" />
      <circle cx="60" cy="52" r="4" fill="#F59E0B" />
      <path
        d="M42 52C42 52 50 40 60 40C70 40 78 52 78 52C78 52 70 64 60 64C50 64 42 52 42 52Z"
        fill="none"
        stroke="#3B82F6"
        strokeWidth="3"
        opacity="0.6"
      />
    </svg>
  );
}
